import Layout from "../../components/Layout";
import { defaultURL, biayaDendaDanBungaMeta } from "../../data/DataMetatags";
import NextHead from "../../components/Seo/NextHead";
import BreadcrumbComponent from "../../components/UserInterface/BreadcrumbComponent";
import { biayaDendaBreadcrumb } from "../../data/DataBreadcrumb";
import HeadingComponent from "../../components/UserInterface/HeadingComponent";
import Description from "../../components/UserInterface/Description";
import DendaTableDesktop from "../../components/BiayaDendaDanBunga/DendaTableDesktop";
import PembiayaanTable from "../../components/BiayaDendaDanBunga/PembiayaanTable";
import { StepsComponent } from "../../components/UserInterface/StepsComponent";
import {
  DataBiayaDendaBunga,
  Keterangan,
} from "../../data/DataBiayaDendaBunga";

const BiayaDendaDanBunga = ({ pageTitle, descriptionSEO, asPath }) => {
  const breadcrumb = [
    {
      "@type": "ListItem",
      position: "1",
      item: {
        "@id": defaultURL,
        name: "Home",
      },
    },
    {
      "@type": "ListItem",
      position: "2",
      item: {
        "@id": defaultURL + asPath,
        name: pageTitle,
      },
    },
  ];
  return (
    <Layout>
      <NextHead
        breadcrumb={breadcrumb}
        title={pageTitle}
        description={descriptionSEO}
        url={asPath}
      ></NextHead>
      <BreadcrumbComponent items={biayaDendaBreadcrumb}></BreadcrumbComponent>
      <DendaTableDesktop></DendaTableDesktop>
      <HeadingComponent
        margin="24px 16px"
        headingText="Biaya Pembiayaan"
      ></HeadingComponent>
      <Description
        margin=" 0 16px"
        text="Home Credit memberlakukan biaya atas layanan pembiayaan yang kami lakukan berdasarkan perhitungan dibawah ini:"
        font="Roboto"
      ></Description>
      <PembiayaanTable></PembiayaanTable>
      <HeadingComponent headingText="INFORMASI BUNGA"></HeadingComponent>
      <Description
        margin="0 16px 24px 16px"
        width="780px"
        align="left"
        text={`Home Credit akan mengenakan bunga terhadap Jumlah Pembiayaan yang sudah termasuk dalam jumlah Pembayaran Cicilan Bulanan.<br><br>
        Jumlah Total Bunga yang dibayar oleh pelanggan selama Jangka Waktu Pembiayaan sama dengan Jumlah Pembiayaan dikalikan dengan Suku Bunga Tetap (yang setara dengan bunga efektif) per bulan dan dikalikan dengan Jumlah Cicilan.<br><br>
        Setiap Pembayaran Cicilan Bulanan (i) terdiri dari pembayaran Jumlah Pembiayaan, bunga dan Biaya Proses Pembayaran Cicilan, (ii) porsi Jumlah Pembiayaan dan bunga dihitung berdasarkan metode jumlah pokok menurun (metode anuitas), dan (iii) akan digunakan pertama-tama untuk pembayaran Jumlah Pembiayaan, diikuti dengan bunga, Biaya Proses Pembayaran Cicilan dan denda.`}
        font="Roboto"
      ></Description>
      <Description
        margin="0 16px 16px 16px"
        align="left"
        width="780px"
        text="Sebelum kamu melanjutkan proses pengajuan, ada beberapa hal penting yang perlu kamu perhatikan:"
        font="Roboto"
      ></Description>
      <StepsComponent
        maxWidth="780px"
        btnBlack
        steps={DataBiayaDendaBunga}
        paddingList="20px"
      />
      <Description
        margin="0 16px 0px 16px"
        align="left"
        width="560px"
        text={`<b>Kisaran Tingkat Suku Bunga Pembiayaan Home Credit:</b>`}
        font="Roboto"
      ></Description>
      <Description
        margin="0 16px 24px 16px"
        align="left"
        width="560px"
        text="Mulai dari 0% sampai dengan 4,99 %"
        font="Roboto"
      ></Description>
      <Description
        margin="0 16px 0px 16px"
        align="left"
        width="680px"
        text={`<b>Keterangan:</b>`}
        font="Roboto"
      ></Description>
      <StepsComponent
        btnDash
        paddingList="20px"
        maxWidth="780px"
        steps={Keterangan}
        marginLeft="50px"
      />
    </Layout>
  );
};

BiayaDendaDanBunga.getInitialProps = ({ asPath }) => {
  const pageTitle = biayaDendaDanBungaMeta.title;
  const descriptionSEO = biayaDendaDanBungaMeta.description;
  return { pageTitle, descriptionSEO, asPath };
};

export default BiayaDendaDanBunga;
